<template>
  <div class="min-h-[100dvh] overflow-y-auto flex flex-col items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-50 dark:from-gray-900 dark:to-gray-800 p-4 py-8">
    <!-- Logo de la empresa -->
    <div class="mb-4 sm:mb-6 text-center flex flex-col items-center mt-auto pt-8">
      <div class="flex items-center justify-center">
        <!-- Logo de SYSTEM JJ -->
        <img 
          src="@/assets/logo/jj.png" 
          alt="SYSTEM JJ Logo" 
          class="w-64 sm:w-72 md:w-80 h-auto max-h-[12vh] object-contain cursor-pointer"
          @error="handleImageError"
          @click="$router.push('/')"
        />
      </div>
    </div>

    <!-- Formulario de Registro -->
    <div class="w-full max-w-md bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden mb-auto">
      <div class="p-5 sm:p-8">
        <div class="mb-6 text-center">
          <h2 class="text-xl sm:text-2xl font-bold text-gray-800 dark:text-white">
            Crear Cuenta
          </h2>
          <p class="text-sm text-gray-600 dark:text-gray-300 mt-1">
            Ingresa tus datos para registrarte
          </p>
        </div>

        <form @submit.prevent="handleRegister">
          <!-- Nombre y Apellido -->
          <div class="grid grid-cols-2 gap-4 mb-4">
            <div>
              <label for="nombre" class="block mb-1 text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
                Nombre
              </label>
              <input
                id="nombre"
                v-model="form.nombre"
                type="text"
                required
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition-colors text-sm"
                placeholder="Tu nombre"
              />
            </div>
            <div>
              <label for="apellido" class="block mb-1 text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
                Apellido
              </label>
              <input
                id="apellido"
                v-model="form.apellido"
                type="text"
                required
                class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition-colors text-sm"
                placeholder="Tu apellido"
              />
            </div>
          </div>

          <!-- Usuario -->
          <div class="mb-4">
            <label for="username" class="block mb-1 text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
              Nombre de Usuario
            </label>
            <input
              id="username"
              v-model="form.username"
              type="text"
              required
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition-colors text-sm"
              placeholder="Ej. juanperez"
            />
          </div>

          <!-- Email -->
          <div class="mb-4">
            <label for="email" class="block mb-1 text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
              Correo Electrónico
            </label>
            <input
              id="email"
              v-model="form.email"
              type="email"
              required
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition-colors text-sm"
              placeholder="tu@email.com"
            />
          </div>

          <!-- Contraseñas -->
          <div class="mb-4">
            <label for="password" class="block mb-1 text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
              Contraseña
            </label>
            <div class="relative">
              <input
                id="password"
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                required
                class="w-full px-3 py-2 pr-10 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition-colors text-sm"
                placeholder="Crea una contraseña"
              />
              <button
                type="button"
                @click="showPassword = !showPassword"
                class="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-gray-600 dark:hover:text-gray-300"
              >
                <svg v-if="!showPassword" class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
                <svg v-else class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M9.878 9.878L6.59 6.59m7.532 7.532l3.29 3.29M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                </svg>
              </button>
            </div>
          </div>

          <div class="mb-5">
            <label for="confirmPassword" class="block mb-1 text-xs sm:text-sm font-medium text-gray-700 dark:text-gray-300">
              Confirmar Contraseña
            </label>
            <input
              id="confirmPassword"
              v-model="form.confirmPassword"
              :type="showPassword ? 'text' : 'password'"
              required
              class="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white transition-colors text-sm"
              placeholder="Confirma tu contraseña"
            />
          </div>

          <!-- Términos -->
          <div class="flex items-start mb-6">
            <div class="flex items-center h-5">
              <input
                id="terms"
                v-model="form.terms"
                type="checkbox"
                required
                class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded"
              />
            </div>
            <label for="terms" class="ml-2 text-xs sm:text-sm text-gray-600 dark:text-gray-300">
              Acepto los <a href="#" @click.prevent class="text-blue-600 hover:underline">términos de servicio</a> y la política de privacidad
            </label>
          </div>

          <!-- Botón de Registro -->
          <button
            type="submit"
            :disabled="loading"
            class="w-full bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white font-medium py-2 sm:py-2.5 px-4 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center text-sm"
          >
            <svg v-if="loading" class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
              <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
              <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
            </svg>
            <span v-if="!loading">Registrarse</span>
            <span v-else>Procesando...</span>
          </button>
        </form>
      </div>

      <!-- Pie del formulario -->
      <div class="px-5 py-3 sm:px-8 bg-gray-50 dark:bg-gray-900/50 border-t border-gray-200 dark:border-gray-700 text-center">
        <p class="text-sm text-gray-600 dark:text-gray-400">
          ¿Ya tienes una cuenta?
          <button
            type="button"
            @click="$router.push('/login')"
            class="text-blue-600 hover:text-blue-500 dark:text-blue-400 dark:hover:text-blue-300 font-medium"
          >
            Inicia sesión aquí
          </button>
        </p>
      </div>
    </div>

    <!-- Información adicional (Branding Profesional) -->
    <div class="mt-6 text-center mb-8">
      <div class="flex flex-col items-center gap-2">
        <div class="flex items-center gap-2 text-[10px] text-slate-400 dark:text-gray-500 uppercase tracking-[0.2em] font-bold">
          <span>Plataforma de Gestión</span>
          <span class="w-1 h-1 rounded-full bg-slate-300 dark:bg-gray-700"></span>
          <span>v1.0.0</span>
        </div>
        <div class="flex items-center justify-center gap-1.5 text-xs text-slate-500 dark:text-gray-400">
          <span class="opacity-80">Desarrollado con</span>
          <svg class="w-3.5 h-3.5 text-rose-500 animate-pulse" fill="currentColor" viewBox="0 0 24 24">
            <path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>
          </svg>
          <span class="opacity-80">por</span>
          <span class="font-black text-indigo-600 dark:text-indigo-400 tracking-tight">SYSTEM JJ</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from 'sweetalert2';

export default {
  name: 'RegisterPage',
  data() {
    return {
      form: {
        nombre: '',
        apellido: '',
        username: '',
        email: '',
        password: '',
        confirmPassword: '',
        terms: false
      },
      showPassword: false,
      loading: false,
      logoError: false,
    };
  },
  mounted() {
    const savedDarkMode = localStorage.getItem('darkMode') === 'true';
    if (savedDarkMode) {
      document.documentElement.classList.add('dark');
    }
  },
  methods: {
    handleImageError() {
      this.logoError = true;
    },
    async handleRegister() {
      if (this.form.password !== this.form.confirmPassword) {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Las contraseñas no coinciden.',
          confirmButtonColor: '#3B82F6'
        });
        return;
      }

      this.loading = true;
      
      try {
        // Simulamos un retraso de red
        await new Promise(resolve => setTimeout(resolve, 1500));
        
        // NOTA: Como es un sistema interno, se simula el registro
        Swal.fire({
          icon: 'success',
          title: '¡Registro Exitoso!',
          text: 'Tus datos han sido enviados. Si se requiere aprobación, un administrador activará tu cuenta pronto.',
          confirmButtonColor: '#3B82F6'
        }).then(() => {
          this.$router.push('/login');
        });

      } catch (error) {
        console.error(error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Hubo un problema al procesar el registro.',
          confirmButtonColor: '#3B82F6'
        });
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style scoped>
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

.min-h-\\[100dvh\\] {
  animation: fadeIn 0.5s ease-out;
}

/* Transiciones suaves */
.transition-colors {
  transition-property: background-color, border-color, color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* Gradiente animado para el botón */
button.bg-gradient-to-r {
  background-size: 200% 200%;
  animation: gradientShift 3s ease infinite;
}

@keyframes gradientShift {
  0% { background-position: 0% 50%; }
  50% { background-position: 100% 50%; }
  100% { background-position: 0% 50%; }
}

/* Efecto hover para tarjetas */
.bg-white, .dark\\:bg-gray-800 {
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.bg-white:hover, .dark\\:bg-gray-800:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.dark .bg-white:hover, .dark .dark\\:bg-gray-800:hover {
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.3);
}
</style>
